'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _avatarWrapper = require('../components/avatar-wrapper');

var _avatarWrapper2 = _interopRequireDefault(_avatarWrapper);

var _responseUtils = require('../response-utils.js');

var _responseUtils2 = _interopRequireDefault(_responseUtils);

var _trafficManager = require('../traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * BotActionApi
 *
 * @Constructor
 * @class BotActionApi
 * @public
 */
var BotActionApi = function (_React$Component) {
  _inherits(BotActionApi, _React$Component);

  function BotActionApi(props) {
    _classCallCheck(this, BotActionApi);

    var _this = _possibleConstructorReturn(this, (BotActionApi.__proto__ || Object.getPrototypeOf(BotActionApi)).call(this, props));

    _this.state = {
      text: _this.replaceTokens(_responseUtils2.default.getFieldValue(_this, 'text', 'string', ''), _responseUtils2.default.getFieldValue(_this, 'errorText', 'string', ''), _this.props.api)
    };
    return _this;
  }

  /**
   * React method called after component mounted
   *
   * @private
   */


  _createClass(BotActionApi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _trafficManager2.default.sendBotActionEvent('cx.help-bot.bot.api', this.props.intent, this.props.sessionId, this.state.text);
    }

    /**
     * @returns {string} Replaces instances of ${field} in text with api field value
     *
     * @param {string} text The custom payload specified text
     * @param {string} errorText The custom payload specified error text
     * @param {Object} api The api results from specified api (e.g. shopper)
     * @private
     */

  }, {
    key: 'replaceTokens',
    value: function replaceTokens(text, errorText, api) {
      if (!api || !api.result) {
        return errorText;
      }

      for (var fieldName in api.result) {
        if (api.result.hasOwnProperty(fieldName)) {
          var tokenRegex = new RegExp('\\$\\{' + fieldName + '\\}', 'ig');
          text = text.replace(tokenRegex, api.result[fieldName]);
        }
      }

      return text;
    }

    /**
     * @returns {React.Element} render
     *
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _avatarWrapper2.default,
        null,
        _react2.default.createElement(
          'div',
          { className: this.state.text ? 'speech-bubble left' : '' },
          this.state.text
        )
      );
    }
  }]);

  return BotActionApi;
}(_react2.default.Component);

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


exports.default = BotActionApi;
BotActionApi.propTypes = {
  msg: _propTypes2.default.object.isRequired,
  api: _propTypes2.default.object.isRequired,
  intent: _propTypes2.default.object.isRequired,
  sessionId: _propTypes2.default.string.isRequired
};